import { jsx } from "react/jsx-runtime";
import { FixedPaymentFieldWUT } from "../../../ui/fixed-payment-field/fixed-payment-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const FixedPaymentWUT = (props) => {
  const { fieldType = FIELD_TYPES.FIXED_PAYMENT } = props;
  return /* @__PURE__ */ jsx(FixedPaymentFieldWUT, { ...props, fieldType });
};
export {
  FixedPaymentWUT
};
//# sourceMappingURL=fixed-payment-wut.js.map
